const initPassiveMonitorFundSelect = (element) => {
  const $element = $(element);
  const fundsPath = element.dataset.fundsPath;

  destroySelect2($element);

  $element.select2({
    theme: 'bootstrap4',
    width: '100%',
    allowClear: true,
    ajax: {
      url: fundsPath,
      dataType: 'json',
      data(params) {
        return {
          q: params.term
        };
      }
    }
  });
};

window.initializePassiveMonitorFundSelects = function initializePassiveMonitorFundSelects(root) {
  const $root = root ? $(root) : $(document);

  $root.find('.JS-invested-funds-passive-monitor:visible').each((_index, element) => {
    initPassiveMonitorFundSelect(element);
  });
};

onLoad(($) => {
  const nodesPassive = $('.JS-invested-funds-passive-monitor');

  if (!nodesPassive.length) return;

  initializePassiveMonitorFundSelects();
});
